export default __webpack_public_path__ + "static/media/tick.664f614c.svg";